import { get, post } from './requests'

const PARTNER_BRANDED_AUDIENCES = 'partner-branded-audiences'
const LEGACY_AUDIENCES = 'legacy-audiences'

export const createBrandedAudience = (payload) => post([PARTNER_BRANDED_AUDIENCES], {}, payload)

export const getBrandedAudience = (id) => get([PARTNER_BRANDED_AUDIENCES, id])

export const searchAudiences = (params) =>
  get([LEGACY_AUDIENCES, 'search'], { removeTrailingSlash: true }, params)
